import { FiscalYearType, ServerFiscalYearType } from '../types/fiscalYear';

export const convertFiscalYearDates = (fiscalYear: ServerFiscalYearType): FiscalYearType => {
	const { startDate, endDate } = fiscalYear;

	return {
		...fiscalYear,
		startDate: new Date(startDate),
		endDate: new Date(endDate),
	};
};
